module.exports = __webpack_public_path__ + "img/veronika_kendoje_0.b6b79c4e.jpg";